import { Message } from "components/message/Message";
import { FC, useState } from "react";
import { i18nService } from "services";
import { InclusionTableRow } from "./InclusionTableRow";
import { IInclusionRow } from "./TableWrapper";
import { TABLE_TYPES } from "../tableTypes";
import { ITussendoortjesRow } from "components/tussendoortjes/types";
import { TussendoortjesTableRow } from "components/tussendoortjes/components/TussendoortjesTableRow";

interface Props {
  filteredRows: (IInclusionRow | ITussendoortjesRow)[];
  sortColumn?: string | null;
  sortDirection?: string | null;
  handleSort: (column: string) => void;
  favorites?: string[];
  addToFavorites: (t: string) => void;
  removeFromFavorites: (t: string) => void;
  tableHeaders: { [key: string]: string };
  tableType: string;
}

export const TableContent: FC<Props> = ({
  filteredRows,
  sortColumn,
  sortDirection,
  handleSort,
  favorites,
  addToFavorites,
  removeFromFavorites,
  tableHeaders,
  tableType,
}) => {
  const [expandedRowTitle, setExpandedRowTitle] = useState<string | null>(null);

  const toggleRow = (title: string) =>
    setExpandedRowTitle(title === expandedRowTitle ? null : title);

  return (
    <>
      {filteredRows.length > 0 ? (
        <table className="table-overview">
          <thead>
            <tr className="table-overview__head">
              <th scope="col" className="table-overview__head__star"></th>
              {Object.keys(tableHeaders).map((key) => {
                const isActive = sortColumn === key;
                const ariaSort = isActive
                  ? sortDirection === "desc"
                    ? "descending"
                    : "ascending"
                  : "none";

                return (
                  <th
                    className={`table-overview__head__${key} ${
                      isActive ? "active-sort" : ""
                    }`}
                    scope="col"
                    aria-sort={ariaSort}
                  >
                    <button
                      type="button"
                      className="table-overview__head-sort"
                      onClick={() => handleSort(key)}
                      aria-label={`${i18nService.copy["table.sortBy"]} ${tableHeaders[key]}`}
                    >
                      {tableHeaders[key]}
                    </button>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {filteredRows.map((row, rowIndex) => {
              switch (tableType) {
                case TABLE_TYPES.INCLUSION:
                  return (
                    <InclusionTableRow
                      row={row as IInclusionRow}
                      rowIndex={rowIndex}
                      expandedRowTitle={expandedRowTitle}
                      toggleRow={toggleRow}
                      favorites={favorites}
                      addToFavorites={addToFavorites}
                      removeFromFavorites={removeFromFavorites}
                    />
                  );
                case TABLE_TYPES.TUSSENDOORTJES:
                  return (
                    <TussendoortjesTableRow
                      row={row as ITussendoortjesRow}
                      rowIndex={rowIndex}
                      expandedRowTitle={expandedRowTitle}
                      toggleRow={toggleRow}
                      favorites={favorites}
                      addToFavorites={addToFavorites}
                      removeFromFavorites={removeFromFavorites}
                    />
                  );
                default:
                  return null;
              }
            })}
          </tbody>
        </table>
      ) : (
        <Message>{i18nService.copy["siteSearch.noResults"]}</Message>
      )}
    </>
  );
};
